import { Injectable } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';
import { rndStr } from '../utils/random';

@Injectable({ providedIn: 'root' })
export class MessageInitService {
  constructor(private messageService: MessageService) {}

  initialize() {
    this.trackMessages();
  }

  private trackMessages() {
    // Adding ID to each message added to message service. This will ensure that each message can be managed separately
    this.messageService.messageObserver.subscribe({
      next: messageInput => {
        if (Array.isArray(messageInput)) {
          messageInput.forEach(message => this.addIdIfNeeded(message));
          return;
        }
        this.addIdIfNeeded(messageInput);
      },
    });
  }

  private addIdIfNeeded(message: ToastMessageOptions) {
    if (message.id) {
      return;
    }
    message.id = rndStr();
  }
}
